import { withTheme, Grid, Paper } from 'material-ui';
import React, { Component } from 'react';

class Page extends Component {
  render() {
    return (
      <Grid container direction='row' justify='center' alignItems='flex-start' spacing={24} style={{padding: '12px 24px'}} {...this.props.containerProps}>
        <Grid item xs={12} sm={11} md={10} lg={9} xl={8}>
          <Paper style={{padding: 48}}>
            {this.props.children}
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

export default withTheme()(Page);


// WEBPACK FOOTER //
// ./src/components/Page.js